import { createSelector } from 'reselect';

// Acounts
const getAccounts = (state) => state.accounts.list.data;
const getAccountsIsLoading = (state) => state.accounts.list.isLoading;
const getAccountsError = (state) => state.accounts.list.hasError;

// Acount Settings
const getAccountSettings = (state) => state.accounts.settings.data;
const getAccountSettingsIsLoading = (state) => state.accounts.settings.isLoading;
const getAccountSettingsError = (state) => state.accounts.settings.hasError;

// Account Invoices
export const selectAccountInvoices = (state) => state.accounts.invoices.data;

// Generation guide - userId
const getUserId = (state) => state.security.user.email;

/**
 * SELECTORS
 */

// Accounts
export const selectAccounts = createSelector([getAccounts], (accounts) => accounts);

export const selectAccountsHasError = createSelector([getAccountsError], (error) => error);

export const selectAccountsIsLoading = createSelector([getAccountsIsLoading], (isLoading) => isLoading);

// Account Settings
export const selectAccountSettings = createSelector([getAccountSettings], (accounts) => accounts);

export const selectAccountSettingsHasError = createSelector([getAccountSettingsError], (error) => error);

export const selectAccountSettingsIsLoading = createSelector(
    [getAccountSettingsIsLoading],
    (isLoading) => isLoading
);

// Generation guide
export const selectUserId = createSelector([getUserId], (userId) => userId);
